import { gql } from '@apollo/client';

export const typeDefs = gql`
  extend type FuelProvider {
    last_known_flowmeter: Float!
  }
  input GetMachineByNameOfflineFilter {
    name: String
  }
  extend type ProjectStats {
    num_machines: Int!
  }
  extend type OtherProjectsStats {
    num_machines: Int!
  }
  extend type MachineReportsBoard {
    total_days_with_reports_hs: Int!
    total_days_with_reports_km: Int!
  }
  extend type MachineReportsStats {
    total_hs: Int!
    total_km: Int!
    total_counters_display: String
  }
  extend type MachinistWorkBoard {
    rate_reported: Float
  }
  extend type User {
    full_name: String
  }
  extend type Employee {
    full_name: String
  }
  extend type Role {
    label: String
  }
  extend type Invitation {
    label: String
  }
  extend type MachineDayReportSummary {
    has_photos: Boolean
    total_counters_display: String
  }
  extend type MachinistDayWorkSummary {
    total_counters_display: String
  }
  extend type DailyReport {
    total_counters_display: String
    total_hs: Float
    total_km: Float
    total_fuel: Float
    total_oil: Float
    creators: [Employee]
    has_grease: Boolean
    has_filters: Boolean
    has_comments: Boolean
    has_tasks: Boolean
  }
  extend type Machine {
    display_name: String
    display_type: String
    last_counter_from_usage_report: MachineCounter
    last_counter_from_fuel_report: MachineCounter
  }
  type NextServiceIn {
    program: MPProgram!
    remaining: ServiceRemaining!
  }
`;
